import { Component, Input } from '@angular/core';
import { OrderHeader, OrderStatus } from '@usf/ngrx-order';

@Component({
  selector: 'app-orders-list-delivered',
  templateUrl: './orders-list-delivered.component.html',
  styleUrls: ['./orders-list-delivered.component.scss'],
})
export class OrdersListDeliveredComponent {
  OrderStatus = OrderStatus;
  @Input() orderHeader: OrderHeader;
}
